import { render, staticRenderFns } from "./PreBidsTable.vue?vue&type=template&id=152364e4&scoped=true"
import script from "./PreBidsTable.vue?vue&type=script&lang=js"
export * from "./PreBidsTable.vue?vue&type=script&lang=js"
import style0 from "./PreBidsTable.vue?vue&type=style&index=0&id=152364e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152364e4",
  null
  
)

export default component.exports